const themeConfig = {
  token: {
    colorPrimary: '#1677ff',
    colorWarningText: '#874d00',
    fontFamily: 'AlibabaSans, sans-serif',
  },
};

export const antdComponentConfig = {
  drawer: {
    styles: {
      root: { position: 'fixed' },
    },
  },
};

export default themeConfig;
